class Bundle {
  constructor(isMobileDevice) { 
    this.isMobileDevice = isMobileDevice;
    this.constraints = JSON.parse(document.querySelector("#bundle-data-constraints").dataset.constraints);
    this.constraints = this._flattenContraints(this.constraints);
    //this.wishlistObject = JSON.parse(document.querySelector("#bundle-data-wishlist").textContent);
    this.previousItem = {
      top: null,
      bottom: null,
      sleeves: null,
    };
    this.preview = {
      top: document.querySelector("#preview-item-image-top"),
      bottom: document.querySelector("#preview-item-image-bottom"),
      sleeves: document.querySelector("#preview-item-image-sleeves")
    };
    this.cartToggler = document.querySelector("#section-header a[href='/cart']");
    this.cartItems = {
      top: document.querySelector("#bundle-cart-item-top"),
      bottom: document.querySelector("#bundle-cart-item-bottom"),
      sleeves: document.querySelector("#bundle-cart-item-sleeves")
    };
    this.cartTotal = document.querySelector("button.bundle-cart-item-cta");
    this.cartTotalPrice = this.cartTotal.querySelector(".price");
    this.cartTotal.addEventListener('click', () => this.addToCart());
    this.shareLinks = document.querySelectorAll(".share-item-link");
    this.wishlistWrapperLink = document.querySelector("#bundle-cart-item-wishlist-redirect");
    this.wishlistWrapper = document.querySelector(".bundle-cart-item-wishlist-wrapper");
    this.addToWishlistIcon = document.querySelector(".bundle-cart-item-wishlist-wrapper .unchecked");
    this.removeFromWishlistIcon = document.querySelector(".bundle-cart-item-wishlist-wrapper .checked");
    this.addedToWishlistPopup = document.querySelector(".bundle-wishlist-modal");
    this.addedToWishlistPopupClose = document.querySelector(".bundle-wishlist-modal-header-close");
    this.keys = ['top', 'bottom', 'sleeves'];
    this.refreshMobileComponents();
  }

  setWishlistObject(wishlist) {
    this.wishlistObject = wishlist;
    this._initWishlist();
  }

  refreshMobileComponents() {
    if(/mobile/i.test(navigator.userAgent) && !/ipad|tablet/i.test(navigator.userAgent)) {
      const wishlistWrapperLink = document.querySelector("#bundle-cart-item-wishlist-redirect");
      const wishlistWrapper = document.querySelector(".bundle-cart-item-wishlist-wrapper");
      if(wishlistWrapper) {
        wishlistWrapper.classList.remove("desktop-only");
      }
      var child = wishlistWrapperLink ? wishlistWrapperLink : wishlistWrapper;
      const mobilePreviewActions = document.querySelector(".bundle-preview-actions");
      if(mobilePreviewActions) {
        mobilePreviewActions.appendChild(child);
      }
    }
  }

  _markAsFavorite(showPopup = true) {
    this.addToWishlistIcon.classList.add("hidden");
    this.removeFromWishlistIcon.classList.remove("hidden");
    if(showPopup) {
      this.addedToWishlistPopup.classList.remove("hidden");
    }
  }

  _unmarkAsFavorite() {
    if(!this.addToWishlistIcon) return;
    this.addToWishlistIcon.classList.remove("hidden");
    this.removeFromWishlistIcon.classList.add("hidden");
    this.addedToWishlistPopup.classList.add("hidden");
  }

  checkIsAlreadyFavorite() {
    let index;
    if(this.wishlistObject) {
      this.wishlistObject.forEach((favorite, idx) => {
        if(favorite.url == window.location.search || favorite.url == window.location.href) {
          index = idx;
          return;
        }
      });
    }
    return index;
  }

  _initWishlist() {
    if(this.checkIsAlreadyFavorite() != null) {
      this._markAsFavorite(false);
    }
    
    this.addedToWishlistPopupClose.addEventListener('click', (e) => {
      this.addedToWishlistPopup.classList.add("hidden");
    });
    
    if(this.addToWishlistIcon) {
      this.addToWishlistIcon.addEventListener('click', (e) => {
        if(this.checkIsAlreadyFavorite() == null) {
          this.updateWishlist();
        } else {
          this._markAsFavorite(false);
        }
      });
    }

    if(this.removeFromWishlistIcon) {
      this.removeFromWishlistIcon.addEventListener('click', (e) => {
        this.removeFromWishlist();
      });
    }
  }

  removeFromWishlist() {
    let existingIdx = this.checkIsAlreadyFavorite();
    if(existingIdx == null) {
      this.wishlistObject.splice(existingIdx, 1);
    } else {
      if(this.wishlistObject.length > 0) {
        this.wishlistObject.splice(this.wishlistObject.length - 1, 1);
      }
    }
    this.updateWishlist(true);
  }

  updateWishlist(removeMode = false) {
    if(!removeMode) {
      this.wishlistObject.push({
        "url": window.location.search,
        "products": {
        },
        "createdAt": new Date().toLocaleString()
      });
      var wishlistId = this.wishlistObject.length - 1;
      this.keys.forEach((id) => {
        let value = this[id];
        if(value && value.productId) {
          this.wishlistObject[wishlistId].products[id] = {
            "productId": value.productId,
            "productName": value.name,
            "productUrl": value.productUrl,
            "imageUrl": this.preview[id].src
          };
        } else {
          delete this.wishlistObject[wishlistId].products[id];
        }
      });
    }
  
    const url = `${window.routes.shopUrl}/apps/wishlist-aca/api/wishlist/update`;
    const data = {
      "customerName": this.wishlistWrapper.dataset.customerName,
      "wishlist": JSON.stringify(this.wishlistObject)
    };
    fetch(url, {
      method: 'POST',
      headers: {
        "content-type": "application/json",
        "ngrok-skip-browser-warning": "skip"
      },
      body: JSON.stringify(data)
    }).then(response => {
      if (response.ok) {
        //console.log("response OK");
        //console.log(response);
        return response.json();
      } else {
        //console.log("response NOK: There was an error");
        throw response;
      }
    }).then(data => {
      //console.log("Data: ");
      //console.log(data);
      if(removeMode) {
        this._unmarkAsFavorite();
      } else {
        this._markAsFavorite();
      }
      //this.updateUrlParams();
    }).catch(error => {
      console.error("Error fetching data: ", error);
      console.log(error.json());
    }); // end fetch
  }

  disableItem(item, itemType, itemTitle) {
    if(item.classList.contains("selected")) {
      this.cartItems[itemType].querySelector(".bundle-cart-item-cb").click();
    }
    const previousIncompatibleItem = item.dataset.type != itemType ? this.previousItem[item.dataset.type] : null;
    if(previousIncompatibleItem) {
      const isSameVariant = item.dataset.selectedVariantId ? 
        previousIncompatibleItem.variantId == item.dataset.selectedVariantId : 
        previousIncompatibleItem.variantId == item.id;
      if(isSameVariant) {
        this.previousItem[item.dataset.type] = null;
        this.resetCartItem(item.dataset.type);
      }
    }
    /*
    item.classList.toggle("disabled");
    item.querySelector(".bundle-product-item-constraint-product").textContent = itemTitle;
    */
    const productName = item.querySelector(".bundle-product-item-constraint-product");
    const currentText = productName.textContent;
    let isDisabled = item.classList.contains("disabled");

    if(!isDisabled) {
      item.classList.add("disabled");
      productName.textContent = itemTitle;
      item.dataset.disabledByCount = 1;
    } else {
      const currentCounter = parseInt(item.dataset.disabledByCount);
      if(currentCounter < 1) {
        item.classList.remove("disabled");
        productName.textContent = itemTitle;
        isDisabled = false;
      } else if(currentCounter == 1) {
        if(currentText.includes(itemTitle)) {
          item.classList.remove("disabled");
          isDisabled = false;
        } else {
          productName.textContent =`${currentText} + ${itemTitle}`;
        }
      } else { // count > 1
        if(currentText.includes(itemTitle)) {
          productName.textContent = currentText.replace(`+ ${itemTitle}`, "").replace(`${itemTitle} +`, "");
          isDisabled = false;
        } else {
          productName.textContent =`${currentText} + ${itemTitle}`;
        }
      }
      item.dataset.disabledByCount = Math.max(0, currentCounter + (isDisabled ? 1 : -1));
    }
    //item.style.willChange = 'auto';
  }

  _updateKeysRecursive(currentConfig, newConfig) {
    if(!currentConfig) { // new key
      return newConfig;
    }

    const currentKeys = Object.keys(newConfig);
    if(!currentKeys || currentKeys.length == 0) {
      return newConfig;
    }

    let mergedObjects = currentKeys.reduce((acc, key) => {
      if(typeof(newConfig[key]) === 'object') {
        acc[key] = this._updateKeysRecursive(currentConfig[key], newConfig[key]);
      } else {
        acc[key] = newConfig[key];
      }
      return acc;
    }, {});

    return {...currentConfig, ...mergedObjects};
  }

  _flattenContraints(contraints) {
    if(!contraints){
      return null;
    }
    let result = {
      collectionLevel: {},
      variantLevel: {},
      productLevel: {}
    };
    Object.keys(contraints).forEach((key) => {
      let value = contraints[key];
      if(key.includes("product-to-collection")) {
        result.collectionLevel = this._updateKeysRecursive(result.collectionLevel, value.collections);
        result.productLevel = this._updateKeysRecursive(result.productLevel, value.products);
      } else if(key.includes("product-to-product")) {
        result.productLevel = this._updateKeysRecursive(result.productLevel, value);
      } else if(key.includes("variant-to-product")) {
        result.variantLevel = this._updateKeysRecursive(result.variantLevel, value.variants);
        result.productLevel = this._updateKeysRecursive(result.productLevel, value.products);
      } else if(key.includes("variant-to-variant")) {
        result.variantLevel = this._updateKeysRecursive(result.variantLevel, value);
      }
    });
    
    return result;
  }

  applyConstraints(id, item, itemVariantId) {
    if(!this.constraints || Object.keys(this.constraints).length == 0) {
      return;
    }

    // Variant level constraint
    const variants = this.constraints.variantLevel;
    const currentVariant = variants[itemVariantId];
    if(currentVariant) {
        let variantItem = document.querySelector(`#v-${itemVariantId}`);
        // variant to variant
        if(currentVariant.variants) {
          currentVariant.variants.forEach((variantId) => {
            let currentVariantItem = document.querySelector(`#v-${variantId}`);
            if(currentVariantItem) {
              this.disableItem(currentVariantItem, item.dataset.variantType, 
                             `${item.dataset.title} - ${variantItem.dataset.variantImageAlt}`);
            }
          });
        }
        // variant to product
        if(currentVariant.products) {
          currentVariant.products.forEach((productId) => {
            let productItem = document.querySelector(`#bundle-product-item-${productId}`);
            if(productItem) {
              this.disableItem(productItem, item.dataset.productType, 
                             `${item.dataset.title} - ${variantItem.dataset.variantImageAlt}`);
            }
          });
        }
    };

    // Product level constraint
    const products = this.constraints.productLevel;
    const currentProduct = products[item.dataset.productId];
    if(currentProduct) {
      // product to variant
      if(currentProduct.variants) {
        currentProduct.variants.forEach((variantId) => {
          let variantItem = document.querySelector(`#v-${variantId}`);
          if(variantItem) {
            this.disableItem(variantItem, item.dataset.variantType, item.dataset.title);
          }
        });
      }
      // product to product
      if(currentProduct.products) {
        currentProduct.products.forEach((productId) => {
          let productItem = document.querySelector(`#bundle-product-item-${productId}`);
          if(productItem) {
            this.disableItem(productItem, item.dataset.productType, item.dataset.title);
          }
        });
      }
      // product to collection
      if(currentProduct.collections) {
        currentProduct.collections.forEach((collectionKey) => {
          document.querySelectorAll(`.${collectionKey}`).forEach((collectionChild) => {
            this.disableItem(collectionChild, item.dataset.productType, item.dataset.title);
          });
        });
      }
    };

    // Collection level constraint
    const collections = this.constraints.collectionLevel;
    Object.keys(collections).forEach((collectionKey) => {
      if(item.classList.contains(collectionKey)) {
        let productIds = collections[collectionKey];
        productIds.forEach((productId) => {
          let collectionChild = document.querySelector(`#bundle-product-item-${productId}`);
          if(collectionChild) {
            this.disableItem(collectionChild, item.dataset.productType, item.dataset.title);
          }
        });
      }
    });
  }

  getUrlParams() {
    let urlParams = "?";
    this.keys.forEach((id, idx) => {
      let value = this[id];
      if(value) {
        let end = idx == this.keys.length - 1 ? "" : "&";
        if(id == "wishlist") {
          urlParams += `${id}=${value}${end}`;
        } else {
          urlParams += `${id}=${value.productId}&v${id}=${value.variantId}${end}`;
        }
      }
    });
    return urlParams;
  }

  updateUrlParams() {
    let currentParams = this.getUrlParams();
    if(currentParams !== window.location.search) {
      let pageUrl = `${window.origin}${window.location.pathname}`;
      let newUrl = `${pageUrl}${currentParams}`;
      window.history.pushState({}, document.title, newUrl);
      this.shareLinks.forEach((link) => {
        if(link.dataset.urlHead) {
          link.href = `${link.dataset.urlHead}${newUrl}`;
        }
      });
    }
  }

  openCartDrawer() {
    const cartIcon = document.querySelector('.header__secondary-nav a[href$="/cart"]');
    cartIcon.click();
  }

  addToCart() {
    // submit cart
    let items = [];
    let updates = {}; 
    this.keys.forEach((id) => {
      if(this[id]) {
        updates[this[id].selectedFormatVariantId] = 1;
        items.push({
          id: this[id].selectedFormatVariantId, 
          quantity: 1
        });
      }
    });

    if(items.length == 0) {
      return;
    }
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({updates: updates})
    })
    .then(response => response.json())
    .then((data) => {
      Object.keys(updates).forEach((currentVariant) => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { // product:added
          bubbles: true,
          detail: {
            variant: currentVariant,
            quantity: 1
          }
        }));
      });

      this.openCartDrawer();
    })
    .catch((e) =>{
      console.log(e);
    });
  }

  updateSelectedFormatVariant(id, variantId) {
    this[id].selectedFormatVariantId = variantId;

    let cartItem = this.cartItems[id];
    let variantPicker = cartItem.querySelector(`.variant-picker`);
    let currentSelectedVariant = variantPicker.querySelector(`.is-selected`);
    if(currentSelectedVariant) {
      currentSelectedVariant.classList.remove("is-selected");
      this.decreaseTotal(this[id].price);
    }

    let newSelectedVariant = variantPicker.querySelector(`[data-variant-id="${variantId}"]`);
    if(newSelectedVariant) {
      newSelectedVariant.classList.add("is-selected");
    }
    
    let formatVariants = this[id].formatVariants;
    let productItem = this[id].item;
    for(let i = 0; i < formatVariants.length; i++) {
      let formatVariant = formatVariants[i];
      if(formatVariant.id == variantId) {
        let newPrice = formatVariant.price / 100;
        let compareAtPrice = formatVariant.compare_at_price ? formatVariant.compare_at_price / 100 : formatVariant.compare_at_price;
        this[id].price = newPrice;
        this.increaseTotal(newPrice);
        let price = this.getFormattedPriceWithDiscounts(newPrice, compareAtPrice);
        cartItem.querySelector(`.bundle-cart-item-price`).innerHTML = `${price}`;
        this.updateCartTotal();
        break;
      }
    }
  }

  generateFormatVariantPickerOptions(id, variantList, selectedFormatVariantId) {
    let variantOptions = [];
    let selectedClass = "";
    let bundleCartItems = document.querySelector(`.bundle-cart-items`);
    let variantLabelDefault = bundleCartItems.dataset.variantLabelDefault;
    
    variantList.forEach((currentVariant) => {
      let isSelected = currentVariant.id == selectedFormatVariantId;
      let p = document.createElement("p");
      p.classList.add("variant-picker-option", "block-swatch");
      if(isSelected) {
        p.classList.add("is-selected");
      }
      p.setAttribute("data-variant-id", currentVariant.id);
      p.setAttribute("data-product-id", this[id].productId);
      p.textContent = currentVariant.public_title ? currentVariant.public_title : variantLabelDefault;
      if(!currentVariant.available) {
        p.classList.add("not-clickable", "is-disabled");
      }
      variantOptions.push(p);
      p.addEventListener("click", (event) => this.updateSelectedFormatVariant(id, currentVariant.id));
    });

    return variantOptions;
  }

  updateCartItem(id, name, price, url, checked = true) {
    let cartItem = this.cartItems[id];
    let link = cartItem.querySelector(`.bundle-cart-item-info-name a`);
    link.textContent = name;
    link.href = url;
    cartItem.querySelector(`.bundle-cart-item-price`).innerHTML = `${price}`;
    cartItem.classList.toggle("selected", checked);

    let currentItem = this[id];
    let variantPicker = cartItem.querySelector(`.variant-picker`);
    variantPicker.innerHTML = "";
    variantPicker.append(...this.generateFormatVariantPickerOptions(id, currentItem.formatVariants, currentItem.selectedFormatVariantId));
  }

  resetCartItem(id) {
    let cartItem = this.cartItems[id];
    let link = cartItem.querySelector(`.bundle-cart-item-info-name a`);
    link.textContent = "";
    link.href = "#";
    let variantPicker = cartItem.querySelector(`.variant-picker`);
    variantPicker.innerHTML = "";
    cartItem.querySelector(`.bundle-cart-item-price`).textContent = `0 ${this.currency}`;
    cartItem.classList.toggle("selected", false);
  }

  updatePreview(id, imageSource = "") {
    this.preview[id].onload = () => {
      document.documentElement.dispatchEvent(new CustomEvent('preview:changed', {
        bubbles: true
      }));
    }
    this.preview[id].src = imageSource;
  }

  setTop(item) {
    this.setItem('top', item);
  } 

  setBottom(item) {
    this.setItem('bottom', item);
  }
  
  setSleeves(item) {
    this.setItem('sleeves', item);
  }

  setWishlist(id) {
    this.wishlist = id;
    this.addToWishlistIcon.click();
  }

  getFormattedPriceWithDiscounts(currentPrice, priceBeforeDiscount = null) {
    const currentPriceWithCurrency = `${currentPrice.toFixed(2)} ${this.currency}`;
    if(!priceBeforeDiscount) {
      return `${currentPriceWithCurrency}`;
    }
    const priceBeforeDiscountWithCurrency = `${priceBeforeDiscount.toFixed(2)} ${this.currency}`;
    const formattedPrice = priceBeforeDiscount <= currentPrice ? 
      currentPriceWithCurrency : 
      `${currentPriceWithCurrency} <span class='strike-text text-subdued'>${priceBeforeDiscountWithCurrency}<span>`;
    return formattedPrice;
  }

  setItem(id, item, variantId = null) {
    let currentItem = this[id];
    if(currentItem) {
      this.decreaseTotal(currentItem.price);
      currentItem.item.classList.remove("selected");
      currentItem.item.querySelector(`#${currentItem.variantId}`).classList.remove("selected");
      this.updateCartItem(id, currentItem.name, currentItem.priceWithCurrency, currentItem.url, false);
      if(currentItem.item != item || currentItem.variantId != variantId) {
        this.applyConstraints(id, currentItem.item, currentItem.variantImageId);
      }
      this[id] = null;
      this.updatePreview(id);
    }
    
    if(!currentItem || (item && (currentItem.item != item || (currentItem.variantId != variantId)))) {
      this.currency = item.dataset.currency;
      const priceVaries = item.dataset.priceVaries == "false" ? false : true; // if variant prices vary
      const currentPrice = parseFloat(item.dataset.price);
      const currentPriceWithCurrency = item.dataset.priceWithCurrency;
      const priceBeforeDiscount = parseFloat(item.dataset.compareAtPrice);
      const priceBeforeDiscountWithCurrency = item.dataset.compareAtPriceWithCurrency;
      const effectivePrice = currentPrice <= priceBeforeDiscount ? currentPrice : priceBeforeDiscount;
      const priceWithCurrency = this.getFormattedPriceWithDiscounts(currentPrice, priceBeforeDiscount);
      currentItem = {
        productId: item.dataset.productId,
        productUrl: item.dataset.url,
        item: item,
        name: item.querySelector(`.bundle-product-item-title`).textContent,
        price: effectivePrice,
        priceWithCurrency: priceWithCurrency,
        originalPrice: currentPrice,
        originalPriceWithCurrency: currentPriceWithCurrency,
        compareAtPrice: priceBeforeDiscount,
        compareAtPriceWithCurrency: priceBeforeDiscountWithCurrency,
        url: item.dataset.url,
        currency: item.dataset.currency,
        variantId: variantId,
        formatVariants: JSON.parse(item.dataset.formatVariants),
        selectedFormatVariantId: item.dataset.firstFormatVariantId
      };
      this[id] = currentItem;
      item.classList.add("selected");
      this.updateCartItem(id, currentItem.name, currentItem.priceWithCurrency, currentItem.url);
      this.increaseTotal(currentItem.price);
      let variant = variantId ? item.querySelector(`#${variantId}`) : item.querySelector(`.bundle-picker-modal-variant`);
      if(variant && variant.dataset) {
        this.updatePreview(id, variant.dataset.variantImageSrc);
        currentItem.variantId = variant.id;
        item.dataset.selectedVariantId = variant.id;
        currentItem.variantImageId = variant.dataset.variantImageId;
        variant.classList.add("selected");
      }
    }
    this.previousItem[id] = currentItem;
    this.updateCartTotal();
    this.updateUrlParams();
    this.applyConstraints(id, item, currentItem.variantImageId);
    this.scrollToCurrentItem(id);
    if(this.checkIsAlreadyFavorite() == null) {
      this._unmarkAsFavorite();
    } else {
      this._markAsFavorite(false);
    }
  }

  togglePrevious(id) {
    if(this.previousItem[id] && !this.previousItem[id].item.classList.contains("disabled")) {
      const currentVariant = document.querySelector(`#${this.previousItem[id].variantId}`);
      if(!currentVariant.classList.contains("disabled")) {
        this.setItem(id, this.previousItem[id].item, this.previousItem[id].variantId);
      }
    }
  }

  scrollToCurrentItem(id) {
    let value = this[id];
    if(value) {
      let item = value.item;
      item.parentNode.scrollTop = item.offsetTop;
      if(this.isMobileDevice) {
        item.parentNode.scrollLeft = item.offsetLeft;
      }
    }
  }

  updateCartTotal() {
    this.cartTotalPrice.textContent = `${this.getTotal()} ${this.currency}`;
  } 

  getTotal() {
    let total = 0;
    this.keys.forEach((id) => {
      if(this[id]) {
        total += this[id].price;
      }
    });
    this.setTotal(total);
    return total;
  } 

  setTotal(total) {
    this.total = total;
  } 

  increaseTotal(value) {
    this.setTotal(this.total + value);
  }

  decreaseTotal(value) {
    this.setTotal(this.total - value);
  }
}

class PreviewHandler {
  constructor(isMobileDevice) {
    this.isMobileDevice = isMobileDevice;
    this.canvas = document.querySelector("#download-preview-canvas");
    this.images = {
      avatar: document.querySelector("#preview-item-image-avatar"),
      top: document.querySelector("#preview-item-image-top"),
      bottom: document.querySelector("#preview-item-image-bottom"),
      sleeves: document.querySelector("#preview-item-image-sleeves")
    };
    this.previousBlobUrl = null;
    this.fileName = document.querySelector("#preview-file-name").textContent;
    this.fileFormat = document.querySelector("#preview-file-format").textContent;
    this.canvas.width = this.images.avatar.naturalWidth;
    this.canvas.height = this.images.avatar.naturalHeight;
    this.downloadPreviewButton = document.querySelector("#bundle-preview-cta-btn");
    //this.downloadPreviewButton.addEventListener('click', (event) => this.downloadCanvas(event));
    this.downloadPreviewButtonMobile = document.querySelector("#bundle-preview-cta-btn-mobile");
    //this.downloadPreviewButtonMobile.addEventListener('click', (event) => this.downloadCanvas(event));
    document.addEventListener('preview:changed', (event) => this.downloadCanvas(event));
  }

  downloadBlobFileReader(blob, name) {
    const reader = new FileReader();
    reader.onloadend = () => {
      //window.open(reader.result, name);
      this._downloadImage(reader.result, name);
    };
    reader.readAsDataURL(blob);
  }
  
  downloadBlob(blob, name) {
    const blobUrl = URL.createObjectURL(blob);
    if(window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, name);
      return;
    }
    this._downloadImage(blobUrl, name);
    if(this.previousBlobUrl) {
      URL.revokeObjectURL(this.previousBlobUrl);
    }
    this.previousBlob = blobUrl;
    return blobUrl;
  }

  downloadDataUrl(url, name) {
    this._downloadImage(url, name);
  }

  _downloadImage(url, name) {
    var link;
    if(document.defaultView.innerWidth > 1130) {
      link = document.querySelector("#bundle-preview-cta-link");
      link.download = name;
    } else {
      link = document.querySelector("#bundle-preview-cta-btn-mobile-link");
    }
    link.href = url;
  }
  
  updateCanvas() {
    var ctx = this.canvas.getContext("2d");
    ctx.clearRect(0,0,this.canvas.width,this.canvas.height);
    //ctx.drawImage(this.images.avatar,0,0);
    ctx.drawImage(this.images.bottom,0,0);
    ctx.drawImage(this.images.top,0,0);
    ctx.drawImage(this.images.sleeves,0,0);
  }
  
  async downloadCanvas(e) {
    this.updateCanvas();
    var _this = this;
    await new Promise(function (resolve, reject) {
      _this.canvas.toBlob((blob) => {
        _this.downloadBlob(blob, _this.fileName);
        resolve();
      }, { type: `image/${_this.fileFormat}`});
    });
  } 

  initDownloadLinks() {
    this.downloadCanvas();
  }
}

window.onload = function () {
  //const isMobileDevice = document.defaultView.innerWidth <= 960;
  const isMobileDevice = /mobile/i.test(navigator.userAgent) && !/ipad|tablet/i.test(navigator.userAgent);
  let urlParams;
  const paramSplit = window.location.href.split('?');
  if(paramSplit) {
    const paramString = paramSplit[1];
    urlParams = new URLSearchParams(paramString);
  }
  
  const downloadPreviewHandler = new PreviewHandler(isMobileDevice);
  const bundle = new Bundle(isMobileDevice);
  const productListTitles = document.querySelectorAll(".bundle-picker-header .product-list-title");
  const productLists = document.querySelectorAll(".bundle-product-list");

  function clearProductListSelection() {
    productListTitles.forEach((productListTitle) => {
      productListTitle.classList.remove("selected");
    });
  }

  function displayProductListById(id) {
    productLists.forEach((productList) => {
      productList.parentNode.classList.add("hidden");
      if(productList.id === id) {
        productList.parentNode.classList.remove("hidden");
        let listIdSplit = productList.id.split("-");
        let listId = listIdSplit[listIdSplit.length - 1];
        
        let tallestItemHeight = getListTallestItemHeight(productList.id);
        if(tallestItemHeight > 0) {
          let extraSpacing = isMobileDevice ? 1 : 2;
          productList.style.height = `calc(${tallestItemHeight}px + ${extraSpacing}rem)`;
        }
        bundle.scrollToCurrentItem(listId);
      }
    });
  }

  function getListTallestItemHeight(id) {
    const list = document.querySelector(`#${id}`);
    const items = list.querySelectorAll(`.bundle-product-item`);
    let tallestItemHeight = document.querySelector(".bundle-preview").offsetHeight;
    items.forEach((item) => {
      if(item.offsetHeight > tallestItemHeight) {
          tallestItemHeight = item.offsetHeight;
        }
    });
    if(tallestItemHeight > 0) {
      list.dataset.tallestItemHeight = tallestItemHeight;
    }
    return tallestItemHeight;
  }
  
  function setHandlers() {
    document.querySelector(`#share-item-link-copy`).addEventListener('click', (event) => {
      navigator.clipboard.writeText(window.location.href);
      document.querySelector(".bundle-clipboard-modal").classList.toggle("hidden");
    });

    document.querySelector(".bundle-picker-modal-header-close").addEventListener('click', (event) => {
      document.querySelector(".bundle-picker-modal").classList.toggle("hidden");
    });

    document.querySelector(".bundle-clipboard-modal-header-close").addEventListener('click', (event) => {
      document.querySelector(".bundle-clipboard-modal").classList.toggle("hidden");
    });
    
    let cartItemCheckboxes = document.querySelectorAll(`.bundle-cart-item-cb`);
    cartItemCheckboxes.forEach((cartItemCb) => {
      cartItemCb.addEventListener('click', (event) => {
          bundle.togglePrevious(cartItemCb.dataset.type);
      });
    });
    
    productListTitles.forEach((productListTitle) => {
      productListTitle.addEventListener('click', (event) => {
        clearProductListSelection();
        productListTitle.classList.add("selected");
        let listIdSplit = productListTitle.id.split("-");
        let listId = listIdSplit[listIdSplit.length - 1];
        displayProductListById(`product-list-${listId}`);
      });
    });

    productLists.forEach((productList) => {
      let listIdSplit = productList.id.split("-");
      let listId = listIdSplit[listIdSplit.length - 1];
      const items = productList.querySelectorAll(`.bundle-product-item`);
      let selectedItem, selectedVariant;
      if(urlParams && urlParams.has(listId)) {
        selectedItem = productList.querySelector(`.bundle-product-item[data-product-id='${urlParams.get(listId)}']`);
        selectedVariant = urlParams.get(`v${listId}`);
      }
      items.forEach((item, index) => {
        if(index == 0 && listId != "sleeves") {
          selectedItem = selectedItem ? selectedItem : item;
        }

        function onVariantSelected(item, variant) {
          variant.classList.toggle("selected");
          bundle.setItem(variant.dataset.variantType, item, variant.id);
          itemModal.classList.toggle("hidden");
        };

        let itemModal = document.querySelector(".bundle-picker-modal");
        item.addEventListener('click', (event) => {
          if(!item.dataset.variantCount || parseInt(item.dataset.variantCount) <= 1) {
            // no variant - no preview to show OR only one variant
            let variantId = item.querySelector(".bundle-picker-modal-variant").id;
            bundle.setItem(listId, item, variantId);
            return;
          }
          
          itemModal.classList.toggle("hidden");
          let itemModalTitle = itemModal.querySelector("#bundle-picker-modal-item-title");
          itemModalTitle.textContent = item.dataset.title;
          let itemModalVariantWrapper = itemModal.querySelector(".bundle-picker-modal-variant-list");
          
          itemModalVariantWrapper.replaceChildren();
          item.querySelector(".variant-list").childNodes.forEach((child) => {
            let childClone = child.cloneNode(true);
            childClone.addEventListener('click', (event) => onVariantSelected(item, childClone));
            itemModalVariantWrapper.appendChild(childClone);
          });
        });

        let itemModalVariants = document.querySelectorAll(".bundle-picker-modal-variant");
        itemModalVariants.forEach((variant) => {
          if(!variant.hasAttribute('listener')) {
            variant.addEventListener('click', (event) => onVariantSelected(item, variant));
            variant.setAttribute('listener', 'true');
          }
        });
        
      });

      productList.addEventListener('scroll', (event) => {
        if(!productList.parentNode.classList.contains("hidden")) {
          let topPosition = Math.round(productList.scrollTop);
          if(topPosition > 0) {
            document.querySelector(".top-shadow").classList.remove("hidden");
          } else {
            document.querySelector(".top-shadow").classList.add("hidden");
          }
  
          if(topPosition >= productList.scrollHeight - productList.clientHeight) {
            document.querySelector(".bottom-shadow").classList.add("hidden");
          } else {
            document.querySelector(".bottom-shadow").classList.remove("hidden");
          }
        }
      });
      
      window.addEventListener('resize', (event) => {
        if(!productList.parentNode.classList.contains("hidden")) {
          displayProductListById(`product-list-${listId}`);
        }
        bundle.refreshMobileComponents();
      });

      // auto-select the first pattern of the category
      // OR select the one from the url
      if(selectedItem) {
        bundle.setItem(listId, selectedItem, selectedVariant);
      }
      displayProductListById(`product-list-top`);
    });
  }

  function fetchWishlist() {
    const url = `${window.routes.shopUrl}/apps/wishlist-aca/api/customer/wishlist`;
    fetch(url, {
      method: 'GET',
      headers: {
        "ngrok-skip-browser-warning": "skip"
      }
    }).then(response => {
      if (response.ok) {
        //console.log("response OK");
        //console.log(response);
        return response.json();
      } else {
        //console.log("response NOK: There was an error");
        throw response;
      }
    }).then(data => {
      //console.log("Data: ");
      //console.log(data);
      if(data.data) {
        bundle.setWishlistObject(JSON.parse(data.data.wishlist));
      } else {
        bundle.setWishlistObject(JSON.parse("[]"));
      }
      if(urlParams) {
        if(urlParams.has("wishlistIt")) {
          // customer was redirected from account creation or login
          if(bundle.addToWishlistIcon) {
            bundle.addToWishlistIcon.click();
          }
        } /*else if(urlParams.has("wishlist")) {
          // customer was redirected from customer account
          if(bundle.addToWishlistIcon) {
            bundle._markAsFavorite(false);
          }
        }*/
      }
      
    }).catch(error => {
      console.error("Error fetching data: ", error);
      console.log(error.json());
    }); // end fetch
  }

  setHandlers();
  downloadPreviewHandler.initDownloadLinks();
  if(bundle.wishlistWrapper && !bundle.wishlistWrapper.classList.contains("disabled")) {
    fetchWishlist();
  } /*else {
    var link = document.querySelector("#bundle-cart-item-wishlist-redirect");
    link.href = `${link.href}?return_to=${window.location.href}wishlistIt`;
  }*/
}